import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="removals"
export default class extends Controller {
  connect() {
    setTimeout(() => this.opacity(), 2900)
    setTimeout(() => this.remove(), 3000)

  }

  remove() {
    this.element.remove()
  }


  opacity() {
    this.element.classList.remove("opacity-100")
    this.element.classList.add("opacity-0")
  }
}
